export type AllocationStabilityPeriod = 'last30' | 'last60' | 'last90' | 'custom'

export const ALLOCATION_STABILITY_TIME_PERIODS: {
  value: AllocationStabilityPeriod
  label: string
}[] = [
  { value: 'last30', label: 'Last 30 days' },
  { value: 'last60', label: 'Last 60 days' },
  { value: 'last90', label: 'Last 90 days' },
  { value: 'custom', label: 'Custom' },
]

export const ALLOCATION_STABILITY_EARLIEST_DATE = new Date(2024, 4, 1)

export const COLOR_REALLOCATION_PRIMARY = '#4206cb'
export const COLOR_REALLOCATION_SECONDARY = '#2596be'
export const COLOR_REALLOCATION_TEXT_SECONDARY = '#3c4a76'
